import React from "react";
import { Calendar } from "../Committee/availability/Calendar";

const TimeSlots = ({}) => {
  return (
    <>
      <div className="mt-6">
        <Calendar />
      </div>
    </>
  );
};

export default TimeSlots;
